import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'scrollbar-hidden overflow-x-auto'
  },
  variants: {},
  defaultVariants: {}
});
